import React from 'react';

const SQLForm = ({
  sqlqn,
  setsqlQn,
  sqltable,
  setTable,
  sqlquery,
  setsqlQuery,
  selectedTables,
  handleCheckboxChange,
  handleRunClick,
  sqlexplain,
  setsqlExplain,
  sqlhints,
  setsqlHints,
  sqltags,
  setsqlTags,
  SQLTestCases,
  setSQLTestCases,
  sqldata,
  sqlerror,
  renderTable,
  addSQLExplanation,
  handleSQLExplainChange,
  addsqlHint,
  handlesqlHintChange,
  addSQLTags,
  handleSQLTagsChange,
  addSQLTestCase,
  handleSQLTestCaseChange
}) => {
  return (
    <div className="container-fluid p-0">
      <nav className="navbar"></nav>
      <div className="form-container">
        <div className="row">
          <div className="col-lg-6 mb-2 col-12">
            <div className="row mb-3">
              <div className="col">
                <label htmlFor="question">Question</label>
                <textarea
                  id="sqquestion"
                  name="question"
                  className="form-control custom-input"
                  value={sqlqn || ""}
                  onChange={(e) => setsqlQn(e.target.value)}
                  required
                ></textarea>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <label htmlFor="question">Table</label>
                <input
                  id="sqtable"
                  name="table"
                  className="form-control custom-input"
                  value={sqltable || ""}
                  onChange={(e) => setTable(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <label>Select table</label>
                <div
                  className="ctbls"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "10px",
                  }}
                >
                  <div>
                    <input
                      type="checkbox"
                      id="lecturers"
                      name="tables"
                      value="Lecturers"
                      onChange={handleCheckboxChange}
                      checked={selectedTables.includes("Lecturers")}
                    />
                    <label htmlFor="lecturers">Lecturers</label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      id="subjects"
                      name="tables"
                      value="Subjects"
                      onChange={handleCheckboxChange}
                      checked={selectedTables.includes("Subjects")}
                    />
                    <label htmlFor="subjects">Subjects</label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      id="marks"
                      name="tables"
                      value="Marks"
                      onChange={handleCheckboxChange}
                      checked={selectedTables.includes("Marks")}
                    />
                    <label htmlFor="marks">Marks</label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      id="companies"
                      name="tables"
                      value="Companies"
                      onChange={handleCheckboxChange}
                      checked={selectedTables.includes("Companies")}
                    />
                    <label htmlFor="companies">Companies</label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      id="branches"
                      name="tables"
                      value="Branches"
                      onChange={handleCheckboxChange}
                      checked={selectedTables.includes("Branches")}
                    />
                    <label htmlFor="branches">Branches</label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      id="students"
                      name="tables"
                      value="Students"
                      onChange={handleCheckboxChange}
                      checked={selectedTables.includes("Students")}
                    />
                    <label htmlFor="students">Students</label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      id="colleges"
                      name="tables"
                      value="Colleges"
                      onChange={handleCheckboxChange}
                      checked={selectedTables.includes("Colleges")}
                    />
                    <label htmlFor="colleges">Colleges</label>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <label htmlFor="expectedQuery">Expected Output Query</label>
                <textarea
                  id="expectedQuery"
                  name="expectedQuery"
                  className="form-control custom-input"
                  value={sqlquery || ""}
                  onChange={(e) => setsqlQuery(e.target.value)}
                  required
                ></textarea>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleRunClick}
                >
                  Run
                </button>
              </div>
            </div>
            <div className="row mb -3">
              <div className="col" id="expectedop">
                <h5>Output Table</h5>
              </div>
            </div>
            <br></br>
            <div id="textAreaContainer" className="">
              <div className="row">
                <div className="col-12">
                  <h5 className="text-muted">Explanation:</h5>
                  {sqlexplain.map((explanation, index) => (
                    <div key={index} className="mb-3 position-relative">
                      <div className="form-group">
                        <label htmlFor={`explanation${index}`}>
                          Explanation {index + 1}:
                        </label>
                        <textarea
                          rows="2"
                          className="form-control custom-input mb-2"
                          value={explanation}
                          onChange={(e) =>
                            handleSQLExplainChange(index, e.target.value)
                          }
                          placeholder="Enter explanation"
                        />
                        <button
                          className="btn-close position-absolute top-0 mt-1 end-0"
                          aria-label="Close"
                          onClick={() => {
                            setsqlExplain((prevExplain) =>
                              prevExplain.filter((_, i) => i !== index)
                            );
                          }}
                        />
                      </div>
                    </div>
                  ))}
                  <button
                    className="btn text-light mt-1 btn-sm"
                    style={{ backgroundColor: "#377383" }}
                    onClick={addSQLExplanation}
                  >
                    Add Explanation
                  </button>
                </div>
                <div className=" col-12">
                  <h5 className="text-muted">Hints:</h5>
                  {sqlhints.map((hint, index) => (
                    <div key={index} className="mb-3 position-relative">
                      <div className="form-group">
                        <label htmlFor={`hint${index}`}>
                          Hint {index + 1}:
                        </label>
                        <input
                          type="text"
                          id={`hint${index}`}
                          className="form-control custom-input mb-2"
                          value={hint}
                          onChange={(e) =>
                            handlesqlHintChange(index, e.target.value)
                          }
                          placeholder="Enter Hint"
                        />
                        <button
                          className="btn-close position-absolute top-0 end-0"
                          aria-label="Close"
                          onClick={() => {
                            setsqlHints((prevHints) =>
                              prevHints.filter((_, i) => i !== index)
                            );
                          }}
                        />
                      </div>
                    </div>
                  ))}
                  <button
                    className="btn text-light btn-sm mt-1"
                    style={{ backgroundColor: "#377383" }}
                    onClick={addsqlHint}
                  >
                    Add Hint
                  </button>
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-12">
                  <h5 className="text-muted">Tags:</h5>
                  {sqltags.map((tag, index) => (
                    <div key={index} className="mb-3 position-relative">
                      <div className="form-group">
                        <label htmlFor={`tag${index}`}>
                          Tag {index + 1}:
                        </label>
                        <textarea
                          rows="2"
                          className="form-control custom-input mb-2"
                          value={tag}
                          onChange={(e) =>
                            handleSQLTagsChange(index, e.target.value)
                          }
                          placeholder="Enter tag"
                        />
                        <button
                          className="btn-close position-absolute top-0 mt-1 end-0"
                          aria-label="Close"
                          onClick={() => {
                            setsqlTags((prevTags) =>
                              prevTags.filter((_, i) => i !== index)
                            );
                          }}
                        />
                      </div>
                    </div>
                  ))}
                  <button
                    className="btn text-light mt-1 btn-sm"
                    style={{ backgroundColor: "#377383" }}
                    onClick={addSQLTags}
                  >
                    Add Tags
                  </button>
                </div>
                <div className=" col-12"> 
                  <h5 className="text-muted mt-4">SQL Test Cases:</h5>
                  {(() => {
                    // Always exclude the last test case from display (it's the expected output)
                    const displayTestCases = SQLTestCases.length > 0 
                      ? SQLTestCases.slice(0, -1) 
                      : [];
                    
                    return displayTestCases.map((testCase, displayIndex) => {
                      const originalIndex = displayIndex; // Since we're excluding only the last one
                      // Ensure testCase is a string (not an array)
                      const testCaseValue = typeof testCase === 'string' ? testCase : (Array.isArray(testCase) ? JSON.stringify(testCase) : '');
                      return (
                        <div key={originalIndex} className="mb-3 position-relative">
                          <label htmlFor={`sqlTestCase${displayIndex}`}>
                            Test Case {displayIndex + 1}:
                          </label>
                          <textarea
                            rows="2"
                            className="form-control custom-input mb-2"
                            value={testCaseValue}
                            onChange={(e) => handleSQLTestCaseChange(originalIndex, e.target.value)}
                            placeholder="Enter testcase"
                          />
                          <button
                            className="btn-close position-absolute top-0 mt-1 end-0"
                            aria-label="Close"
                            onClick={() => {
                              setSQLTestCases((prevTestCases) =>
                                prevTestCases.filter((_, i) => i !== originalIndex)
                              );
                            }}
                          />
                        </div>
                      );
                    });
                  })()}
                  <button
                    className="btn text-light mt-1 btn-sm"
                    style={{ backgroundColor: "#377383" }}
                    onClick={addSQLTestCase}
                  >
                    Add Test Case
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-12">
            <div
              className="row"
              style={{ height: "100%", maxHeight: "900px", overflowY: "auto" }}
            >
              <div className="tables">
                <div>
                  <h5 style={{ textAlign: "center" }}>Tables</h5>
                  {sqlerror ? (
                    <p>Error fetching data: {sqlerror}</p>
                  ) : Object.keys(sqldata).length ? (
                    Object.keys(sqldata).map((key) => renderTable(key.charAt(0).toUpperCase() + key.slice(1), sqldata[key]))
                  ) : (
                    <p>Loading...</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SQLForm; 